enum TxpSettingsEntryPoint {
    /** User changed the setting from the full settings panel */
    FullSettings,

    /** User changed the setting from the card settings popup */
    CardSettings,
}

export default TxpSettingsEntryPoint;
